import React, {useEffect, useState} from "react";
import moment from "moment";
import {useTranslation} from "react-i18next";
import InstrumentIcon from "../../instrument-icon";

const NotificationsWelcomeBonus = (props) => {

    const {t} = useTranslation()
    const {timestamp, lang_key, data} = props
    // todo [ti-circle-check,ti-circle-x,ti-info-circle,ti-info-gift]

    const [instance, setInstance] = useState({
        amount: '', code: ''
    })

    useEffect(() => {
        if (data) {
            try {
                const item = JSON.parse(data)
                setInstance({
                    amount: item?.amount,
                    code: item?.currency || item?.code,
                })
            } catch (e) {
                // console.log(' e.message => ', data)
                if (data?.amount) {
                    setInstance({
                        amount: data?.amount,
                        code: data?.currency || data?.code,
                    })
                }
            }
        }
    }, [data])

    return (
        <li>
            <a onClick={null} className="green tip">
                <div className="d-flex align-items-center justify-content-center">
                    <InstrumentIcon code={instance.code}/>
                    <div className="d-flex flex-column">
                        <span className="title">
                            {t(`notifications.${lang_key}`, instance)}
                        </span>
                        {/*<span>{instance.amount}</span>*/}
                    </div>

                </div>
                <span className="date">{moment.unix(timestamp).format('MMM Do YY')}</span>
            </a>
        </li>
    )
}

export default NotificationsWelcomeBonus
